export const SEPARATOR_STROKE = 'rgba(153,153,153,0.5)';

const ReportTypes = {
  STATEMENTS: 0,
  RECEIVED_FROM_RM: 1
}

const ALL_REPORT_PORTFOLIO = {
  "id": "00000000.00",
  "title": "All Portfolios",
  "referenceCurrency": "",
  "relId": null,
  "branchCode": 4,
  "isPaymentAvailable": true
};

const DURATION = {
  LAST_WEEK: 'for last week',
  LAST_MONTH: 'for last month',
  LAST_90_DAYS: 'for last 90 days',
  DATES: 'within these dates'
};

const PALETTE = {
  primaryActive: '#e29317',
  primaryText: '#edf2f1',
  primaryTextDisabled: '#999',
  primaryStrokeLine: SEPARATOR_STROKE,
  secondaryActive: '#ffffff',
  secondaryText: '#999',
  secondaryTextDisabled: '#333',
  secondaryDisabled: '#eceef0',
  secondaryBackground: '#333',
  lineChartColor: '#d4d73c',
  lineChartAxisColor: '#999',
  lineChartGridColor: '#999',
  bottomNavBackground: '#000',
  bottomNavSeparator: '#333',
  bottomNavItem: '#999',
  appBackground: '#000',
  errorColor: '#E3002D',
  successColor: '#7AB800',

  // extras
  primaryNegative: '#fa3850',
  primaryPositive: '#7ab800',
};

const SELECTED_RANGE = {
  LAST_WEEK: 0,
  LAST_MONTH: 1,
  LAST_90_DAYS: 2,
  CUSTOM: 3
};

const DATE_FORMAT = {
  EDELIVERY: "YYYY-MM-DDTHH:mm:ssZ"
}

const CATEGORY_ID = [
  "1002",
  "2002",
  "3002",
  "5002",
  "6002",
  "7002",
  "4002"
];

const REPORT_PORTFOLIO_ID = "00000000.00";

const EDELIVERY = {
  UNREAD_CATEGORY_ID: -1,
};

const EDELIVERY_CATEGORY_ID = {
  PORTFOLIO_STATEMENTS: 2002,
  ACCOUNT_STATEMENTS: 3002,
  ADVICES: 1002,
  TAX_STATEMENTS: 6002,
  OTHER_DOCUMENTS: 7002,
  CONTRACTUAL_DOCUMENTS: 61002,
  FROM_YOUR_ADVISOR: 41002
};

const CSV = '.csv';
const TXT = '.txt';
const PDF = '.pdf';
const PDF_MIME_TYPE = "Application/pdf";
const SUCCESS_RESPONSE_CODE = 200;

const CUSTOM_REPORT_TYPES = {
  TRANSACTION_HISTORY: 0,
  POSITION_SEARCH: 1
}

const CUSTOM_REPORT_SELECTED_RANGE = {
  LAST_WEEK: 0,
  LAST_MONTH: 1,
  PAST_THREE_MONTHS: 2,
  CUSTOM: 3
};

const PAGE = {
  pageSize: 15,
};

const ITEM_PER_PAGE = 10;

const SCROLL_DIRECTION = {
  UP: 'up',
  DOWN: 'down'
}
const DE = 'de';

const DATE_RANGE = {
  DATE:'01/01/1900'
}
const FILTER_CATEGORY= {
  ALL: 'ALL',
  READ: 'READ',
  UNREAD: 'UNREAD',
}
export {
  ReportTypes,
  ALL_REPORT_PORTFOLIO,
  DURATION,
  SELECTED_RANGE,
  DATE_FORMAT,
  CATEGORY_ID,
  REPORT_PORTFOLIO_ID,
  EDELIVERY,
  EDELIVERY_CATEGORY_ID,
  CSV,
  TXT,
  PDF,
  PDF_MIME_TYPE,
  SUCCESS_RESPONSE_CODE,
  CUSTOM_REPORT_TYPES,
  CUSTOM_REPORT_SELECTED_RANGE,
  PALETTE,
  PAGE,
  ITEM_PER_PAGE,
  SCROLL_DIRECTION,
  DE,
  DATE_RANGE,
  FILTER_CATEGORY
}
export const SUCCESS_RETURN_CODE = "0";

export const REPORT_CATEGORY = {
  ADVICES: 'Advices',
  CORPORATE_ACTIONS: 'Corporate Actions',
  PORTFOLIO_STATEMENTS: 'Portfolio Statements',
  ALL_DOCUMENTS: 'All Documents'
}
